module.exports = __webpack_public_path__ + "img/mojari.6c2d4369.jpg";